<template>
  <hm-content>
    <el-table
        :data="list"
        border
        stripe
        size="small"
        style="width: 100%">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
          prop="phone"
          label="手机号"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="name"
          label="用户姓名"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="org"
          label="所属机构"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="js"
          label="角色"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="status"
          label="状态"
          header-align="center"
          align="center"
      >
        <template slot-scope="scope">
          <span style="color: #2FC348;">{{scope.row.statis == 'yes' ? '在职' : '离职'}}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="time"
          label="加入时间"
          header-align="center"
          align="center"
      >
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          phone: "13121869388",
          name: "李三盒",
          org: "总部",
          js: "公司负责人",
          statis: "yes",
          time: "2021-01-28"
        }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
    };
  },
  created() {},
  mounted() {},
  methods: {
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
